/**
 * @generated SignedSource<<f1754651bda8bd625ed4538308d830d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueOverviewIssueItemImageThumbanil_issue$data = {
  readonly images: ReadonlyArray<{
    readonly id: string;
  }> | null;
  readonly " $fragmentType": "WidgetIssueOverviewIssueItemImageThumbanil_issue";
};
export type WidgetIssueOverviewIssueItemImageThumbanil_issue$key = {
  readonly " $data"?: WidgetIssueOverviewIssueItemImageThumbanil_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueOverviewIssueItemImageThumbanil_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueOverviewIssueItemImageThumbanil_issue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "4298001c471b5b5040ada3a561af68d8";

export default node;
